export default __webpack_public_path__ + "scripts/resources/assignments/en/kinetics/k5/solutions.json";